const PageName = {
  landing: "LandingPage",
  detail: "DetailsPage",
  contactSales: "ContactSalesPage",
  summary: "SummaryPage",
  thankyou: "ThankYouPage",
  failure: "FailurePage"
}

export default PageName
